import type { TOC } from '@ember/component/template-only';
import { local } from 'embroider-css-modules';
import isDrawerExpanded from 'lumen/helpers/is-drawer-expanded';
import { DRAWER_IDS } from 'lumen/utils/constants/general-constants';

import styles from './header.module.css';

interface GeneralPageHeaderSignature {
  Args: {
    isSmall?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const GeneralPageHeader: TOC<GeneralPageHeaderSignature> = <template>
  <header
    class={{local
      styles
      "header"
      (if @isSmall "header--small")
      (if
        (isDrawerExpanded DRAWER_IDS.SMART_INSIGHTS_DRAWER)
        "smart-insights-open"
      )
    }}
    ...attributes
  >
    {{yield}}
  </header>
</template>;

export default GeneralPageHeader;
